<template>
    <div>
        <QuizEditorNav />
        <QuizStepper step="4" />
        <br></br>
        <div class="container">
            Quiz: <b>{{quiz.title}}</b><hr>
            <form action="#" v-if="categories.length>0">
              <br>Please assign the quiz to a category
                <p v-for="(category, key) in constituents" :key="category.id">
                <label>
                    <input name="group1" type="radio" :value="key" v-model="assignedCategory" />
                    <span>{{category.title}}<a :href="'/categories/build/' + key" >&nbsp;<i class="tiny material-icons">launch</i> </a></span>
                </label>
                <br><br><br><p>
                  
                  <p><br><a class="btn blue" @click="navigateToQuizzes()" :disabled="assignedCategory==''">
                Publish Quiz 
              </a>
                  &nbsp;&nbsp;<a class="btn blue" :disabled="assignedCategory!=''" @click="navigateToQuizzes()">
                Skip for now and publish quiz
                </a></p>
                </p>
            </form>
            <div v-else>
              <br>You don't have any categories. <br><br>Categories help you group related content, such as tutorials and quizzes around specific topics. <p>Would you like to create one now? (Your quiz progress has been saved.)</p>
              <p><br><a class="btn blue" @click="createCategory()">
                Create a category
              </a>
              <a class="btn blue" @click="navigateToQuizzes()">
                Skip for now and publish quiz
              </a>
              </p>
            </div>
        </div>
        <!-- Modal Structure -->
  <div id="modalFeatureGate" class="modal feature-modal modal-fixed-footer">
    <div class="modal-content">
      <h3>Upgrade to activate additional quizzes</h3>
      <p v-if="showFreeBanner" style="font-size:20px" >The free plan allows for one active quiz.</p>
      <p v-if="showMakerBanner" style="font-size:20px" >The Maker plan allows for one active quiz.</p>
      <p v-if="showTeamBanner" style="font-size:20px" >The Team plan allows for ten active quizzes.</p>
      
      <p style="font-size:20px">Head on over to the <a href="/settings#plan">select a plan page</a> to pick the right plan for your needs.</p>
    </div>
    <div class="modal-footer">
      <a @click="navigateToQuizzes()" class="modal-close waves-effect waves-green btn-flat">Save and activate later</a>
      <a href="/settings#plan" class="modal-close waves-effect waves-green btn-flat">Select a plan</a>
    </div>
  </div>
    </div>
</template>
<script>
import QuizEditorNav from "@/components/QuizEditorNav";
import QuizStepper from "@/components/QuizStepper";
import cognitoAuth from "@/plugins/cognito";
import GqlV2Query from "@/plugins/gqlV2";
import featureGate from '@/mixins/featureGate'
export default {
  mixins: [featureGate],
  async mounted() {
    let self = this;
    document.title = "fyiio | quiz assigner";
    cognitoAuth.getIdToken(function(err, jwttoken) {
      self.token = jwttoken;
    })
    cognitoAuth.getUserAttributes(function(err, user_attributes) {
      self.organization_id = user_attributes['custom:organization_id'];
      self.loadQuizzes();
    })
   
    this.loadQuiz();
    this.loadCategories();
  },
  updated() {
    M.AutoInit();
  },
  watch: {
    assignedCategory: function (newCat, oldCat) {
      let self = this;
      if (self.assignedCategoryInitialLoad) {
        self.assignedCategoryInitialLoad = false;
        return;
      }
      if(this.checkCanAssignCategory()){
      //Per the spec, let them assign it to one and only one category here.
      GqlV2Query.getCategoriesForQuiz(self.id, (err, result) => {
        if (err) {
          this.error = err;
        } else {
          let categories = result.data.quizzes_by_category;
          categories.forEach((category) => {
            if (category.id == newCat) return; //no need to remove it from the desired category
            let newContent = category.category.content.filter(function (e) {
              return e.id != self.id;
            });
            self.updateCategoryContent(category, newContent);
          });
          GqlV2Query.getCategory(newCat, (err, result) => {
            let category = result.data.category[0];
            let content = category.content;
            let quizzer = {};
            quizzer.type = "quiz";
            quizzer.id = self.id;
            quizzer.title = self.quiz.title;
            content.push(quizzer);
            self.updateCategoryContent(category, content);
          });
        }
      });
    }
      //Add quiz to the new category, per spec, just add it at the end.
    },
  },
  data() {
    return {
      token:'',
      organization_id:'',
      assignedCategory: "",
      assignedCategoryInitialLoad: true,
      constituents: {},
      categories: {},
      quiz: {},
      quizzes: [],
      quiz_categories: [],
      id: this.$route.params.id,
      title: "",
      description: "",
      loading: true,
    };
  },
  computed: {},
  methods: {
    loadQuizzes() {
      console.log("inLoadQuizzes")
      var self = this;
      let variables={
        organization_id: self.organization_id
      }
      //console.log(variables);
      GqlV2Query.getQuizzes(variables, (err, result) => {
            if (err) {
              this.error = err;
            } else {
              //console.log(result)
              self.quizzes = result.data.quiz;
              self.loading = false;
              M.AutoInit();
            }
            self.checkProceed();
        }
      )
    },
    async checkCanAssignCategory(){
      const canProceed = await this.checkPlanForQuizzes(this.quizzes);
        if (!canProceed) {
          this.featureGateAction('Plan limit reached');
          // if activation cannot proceed, stop execution of activateToggle
          return false;
        }
    }, 
    async checkProceed(){
      const canProceed = await this.checkPlanForQuizzes(this.quizzes);
        if (!canProceed) {
          this.featureGateAction('Plan limit reached');
          // if activation cannot proceed, stop execution of activateToggle
          return;
        }
    }, 
    featureGateAction(action) {
      var options = {dismissible: false};
      var elem = document.querySelector('.feature-modal');

      // allow time for dom to react to data change
      setTimeout(function(){
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 1)
    },
    navigateToQuizzes(){
      window.location.href="/quizzes"
    },
    createCategory(){
      window.location.href="/categories/new"
    },
    updateCategoryContent(category, newContent) {
      let variables = {};
      variables.id = category.id;
      variables.content = newContent;
      GqlV2Query.updateCategoryContent(variables, (err, result) => {
        if (err) {
          this.error = err;
        } 
      });
    },
    loadCategories() {
      let self = this;
      let variables={}
      GqlV2Query.getCategories(variables, (err, result) => {
        if (err) {
          this.error = err;
        } else {
          self.categories = result.data.category;
          self.categoriesLoading = false;

          for (let i = 0; i < self.categories.length; i++) {
            self.constituents[self.categories[i].id] = {};
            self.constituents[self.categories[i].id]["type"] = "category";
            self.constituents[self.categories[i].id]["title"] =
              self.categories[i].title;
          }
          M.AutoInit();
          self.$forceUpdate();
        }
      });
    },
    loadQuiz() {
      let self = this;
      GqlV2Query.getQuiz(self.id, (err, result) => {
        let quiz = result.data.quiz[0];
        self.quiz = quiz;
        self.title = quiz.title;
        self.description = quiz.description;
        self.quiz_categories = quiz.quiz_categories;
        if (quiz.quiz_categories.length == 0) {
          self.assignedCategoryInitialLoad = false;
        } else {
          self.quiz_categories.forEach((quizcat) => {
            self.assignedCategory = quizcat.id;
          });
        }
        self.loading = false;
        M.AutoInit();
      });
    },
  },
  components: {
    QuizEditorNav,
    QuizStepper,
    cognitoAuth,
    GqlV2Query,
    cognitoAuth
  },
};
</script>


// WEBPACK FOOTER //
// src/containers/dashboard/quizzes/AssignQuiz.vue